import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { NoContentResponse } from '@/types/api'
import { CreateServiceRequest } from '@/types/requests/services'

class ServiceService {
  private endpoint = `${API_PATH_INTERNAL}/services`

  async createService(request: CreateServiceRequest) {
    const response = await apiService.post(this.endpoint, request)

    return response.data
  }

  async deleteService(serviceId: number): Promise<NoContentResponse> {
    const response = await apiService.delete<NoContentResponse>(
      `${this.endpoint}/${serviceId}`,
    )

    return response.data
  }
}

const serviceService = new ServiceService()

export default serviceService
